import { render, staticRenderFns } from "./ListSectors.vue?vue&type=template&id=f2dd1f36&lang=html&"
import script from "./ListSectors.vue?vue&type=script&lang=js&"
export * from "./ListSectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports